/* eslint-disable camelcase, no-undef, no-unused-vars, class-methods-use-this, max-classes-per-file */
import {Tooltip} from 'bootstrap';
import {filterChoices, filterData} from '../enums/api.js';
// eslint-disable-next-line import/prefer-default-export
export class Nav {
  constructor() {
    this.add_active_to_main_nav();
    this.allow_hover_on_main_nav();
  }

  // this function adds the class "active" to the main nav link that matches the current url
  add_active_to_main_nav() {
    let current_url = window.location.pathname,
        subdir = current_url.split('/')[1];

    window.$('.navbar-nav .nav-link').each(function() {
      let el = $(this),
          url = el.data('url');
      if (url && subdir === url.split('/')[1]) {
        el.addClass('active');
      }
    });
  }

  allow_hover_on_main_nav() {
    Array.from(document.querySelectorAll('.navbar .dropdown')).forEach((dropdown) => {
      let toggle = dropdown.querySelector('.dropdown-toggle'),
          menu = dropdown.querySelector('.dropdown-menu');
      toggle.addEventListener('mouseover', (event) => {
        new window.base_js.bootstrap.Dropdown(toggle).show();
      });
      toggle.addEventListener('mouseout', (event) => {
        if (dropdown.contains(event.relatedTarget)) return; // quit if the mouse is within the dropdown menu
        if (window.base_js.bootstrap.Dropdown && window.base_js.bootstrap.Dropdown.getInstance(toggle)) {
          window.base_js.bootstrap.Dropdown.getInstance(toggle).hide();
        }
      });
      menu.addEventListener('mouseout', (event) => {
        if (dropdown.contains(event.relatedTarget)) return; // quit if the mouse is within the dropdown menu
        if (window.base_js.bootstrap.Dropdown && window.base_js.bootstrap.Dropdown.getInstance(toggle)) {
          window.base_js.bootstrap.Dropdown.getInstance(toggle).hide();
        }
      });
    });
  }
}

export class BaseFilters {
  constructor() {
    this.setupAppliedFilters();
    this.filter_choices = filterChoices;
    this.filter_data = filterData;
  }

  /**
   * @deprecated
   */
  setupAppliedFilters() {
    window.$('[data-applied-filters] button').each(function() {
      let $btn = window.$(this),
          param = $btn.data('param'),
          re = new RegExp(`([&?])(${param}=)([^&]$|[^&]*)`, 'i'),
          is_range = $btn.data('type') === 'range',
          is_param_found = window.location.href.match(re),
          {href} = window.location;

      if (!is_param_found) {
        href += (window.location.href.indexOf('?') === -1) ? '?' : '&';
        href += (is_range) ? `${param}_0=&${param}_1=` : `${param}=`;
      } else if (is_range) {
        let range_start = new RegExp(`([&?])(${param}_0=)([^&]$|[^&]*)`),
            range_stop = new RegExp(`([&?])(${param}_1=)([^&]$|[^&]*)`);
        href = href.replace(range_start, '$1$2');
        href = href.replace(range_stop, '$1$2');
      } else {
        href = window.location.href.replace(re, '$1$2');
      }
      if ($btn.data('required') === 'True') {
        $btn.next('.btn-remove').remove();
      } else {
        $btn.next('.btn-remove').attr('href', href);
      }
    });
  }
}

export class BootstrapDependencies {
  constructor() {
    this.setupTooltips();
    this.setupPopovers();
    this.setupOffcanvas();
  }

  setupTooltips() {
    const setup = () => {
      window.Tooltip = Tooltip; // expose it on window for v-tooltip to use

      let tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map((el) => Tooltip.getOrCreateInstance(el, {
        container: el.parentElement,
        animation: false,
      }));
    };
    // immediately invoke tooltip setup for traditional django pages
    setup();
    // delayed invoke tooltip setup for vue pages because vue html is not rendered yet
    // in the future we should probably instantiate the tooltip inside of v-tooltip, making sure that the code only runs once
    setTimeout(setup, 2000);
  }

  setupPopovers() {
    // This is in a setTimeout since some Vue apps aren't rendered at this time
    const setup = () => {
      let popoverTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="popover"]'));
      popoverTriggerList.map((el) => new window.base_js.bootstrap.Popover(el, {
        html: true,
        trigger: 'click hover',
        container: el.parentElement,
      }));
    };
    // immediately invoke popover setup for traditional django pages
    setup();
    // delayed invoke popover setup for vue pages because vue html is not rendered yet
    // in the future we should probably instantiate the popovers a popover directive making sure the code runs only once
    setTimeout(setup, 2000);
  }

  setupOffcanvas() {
    let off_canvas_toggle = document.querySelector('[data-bs-toggle="offcanvas"]');
    if (off_canvas_toggle) {
      off_canvas_toggle.addEventListener('click', () => {
        document.querySelector('.offcanvas-collapse').classList.toggle('open');
        document.querySelector('body').classList.toggle('overflow-hidden');
      });
    }
  }
}

export class BaseAPI {
  decode_escapejs(string) {
    // eslint-disable-next-line no-useless-escape
    return decodeURIComponent(JSON.parse(`"${string.replace(/\"/g, '\\"')}"`));
  }

  setup_ajax(csrf_token) {
    function csrfSafeMethod(method) {
      // these HTTP methods do not require CSRF protection
      return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    window.$.ajaxSetup({
      beforeSend(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader('X-CSRFToken', csrf_token);
        }
      },
    });
  }
}

export class BaseUtils {
  constructor() {
    this.setupClickableRows();
    this.setupImpersonateBtns();
    this.disableNewUserCreateText();
  }

  setupClickableRows() {
    let $table = window.$('.table-clickable-row'),
        $tds = $table.find('td'),
        excluded_columns = $table.data('clickable-excluded-columns'),
        clickable_column = $table.data('clickable-column');

    $tds.on('click', function(e) {
      let $td = window.$(this),
          $tr = $td.parent('tr'),
          $link = $tr.find('a'),
          $target = window.$(e.target);

      if ($target.hasClass('btn') || $target.prop('nodeName') === 'BUTTON') {
        return;
      }

      if (excluded_columns !== undefined) {
        let $column_clicked_string = String($td.index()),
            $excluded_columns_list = String(excluded_columns).split(',');

        if ($excluded_columns_list.indexOf($column_clicked_string) !== -1) {
          return;
        }
      }

      if (clickable_column !== undefined) {
        $link = $tr.find('td').eq(clickable_column).find('a');
      }

      window.location = $link.attr('href');
    });
  }

  setupImpersonateBtns() {
    let $impersonate_btns = window.$('.impersonate-btn');

    if ($impersonate_btns.length > 0) {
      let $btn_parents = $impersonate_btns.parent();
      $btn_parents.on('mouseenter', function() {
        window.$(this).find('.impersonate-btn').stop(true, true).show();
      });
      $btn_parents.on('mouseleave', function() {
        window.$(this).find('.impersonate-btn').stop(true, true).hide();
      });
    }
  }

  disableNewUserCreateText() {
    let $add_btn = window.$('.c-page-header .add-btn'),
        $new_user_create_text = window.$('.new_user_create_text');

    if ($new_user_create_text.length > 0 && $add_btn.length > 0 && $add_btn.attr('disabled') === 'disabled') {
      $new_user_create_text.hide();
    }
  }

  /**
   * @deprecated
   */
  setupOrderedColumns(order_by, ordering) {
    let orderBy = order_by;
    if (orderBy.match(/^-/)) {
      orderBy = orderBy.replace(/^-/, '');
    }

    window.$('.order-by-column').each(function() {
      let $el = $(this),
          column_name = $el.data('column'),
          {href} = window.location,
          next_order = 'asc',
          has_query_string = (href.indexOf('?') !== -1),
          order_by_param,
          ordering_param;

      if (orderBy === column_name) {
        $el.addClass('current');
        $el.addClass(ordering);
        $el.append('<span class="caret"></span>');
        if (ordering === 'asc') {
          $el.addClass('dropup');
          next_order = 'desc';
        }
      }

      order_by_param = `order_by=${column_name}`;
      ordering_param = `ordering=${next_order}`;

      if (!has_query_string) {
        href = `?${order_by_param}&${ordering_param}`;
      } else {
        if (href.match(/ordering=(asc|desc)/)) {
          href = href.replace(/ordering=(asc|desc)/, ordering_param);
        } else {
          href += `&${ordering_param}`;
        }

        if (href.match(/order_by=[_\w]+/)) {
          href = href.replace(/order_by=([_\w]+)/, order_by_param);
        } else {
          href += `&${order_by_param}`;
        }
      }

      $el.attr('href', href);
    });
  }
}
